<template>
    <div class="share-links">
        <ul class="item-list list-unstyled">
            <li
                v-for="account in accounts"
                :key="account.network"
                class="item"
            >
                <share-network
                    :network="account.network"
                    twitter-user="ItsuOfficial"
                    :title="title"
                    :url="shareUrl"
                    :media="media"
                    class="share-btn btn btn-outline-primary"
                >
                    <app-icon
                        :name="account.icon"
                        :title="`Share via ${ account.siteName }`"
                        v-test:icon
                    />
                </share-network>
            </li>
        </ul>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueSocialSharing from 'vue-social-sharing';

    Vue.use(VueSocialSharing);

    export default {
        name: 'share-links',

        props: {
            title: {
                type: String,
                required: true,
            },

            media: {
                type: String,
                default: '',
            },
        },

        computed: {
            /**
             * Get the social media accounts.
             *
             * @returns {Array}
             */
            accounts() {
                return [
                    {
                        siteName: 'Email',
                        icon: 'mail',
                        network: 'email',
                    },
                    {
                        siteName: 'Facebook',
                        icon: 'facebook',
                        network: 'facebook',
                    },
                    {
                        siteName: 'Twitter',
                        icon: 'twitter',
                        network: 'twitter',
                    },
                    {
                        siteName: 'LinkedIn',
                        icon: 'linkedin',
                        network: 'linkedin',
                    },
                ];
            },

            /**
             * Get the URL to share.
             *
             * @returns {string}
             */
            shareUrl() {
                return [
                    this.$config.APP_URL,
                    this.$route.path,
                ].join('');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .item-list {
        margin: 0 -9px;
        display: flex;
        list-style: none;
    }

    .item {
        padding-left: 9px;
        padding-right: 9px;
    }

    .share-btn {
        min-width: unset;
        width: 35px;
        height: 35px;
        padding: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
